import { RemoteObject } from './remote-object.model';

// tslint:disable:variable-name

export class SPHLicense extends RemoteObject {
    public static fromJSON(json: any): SPHLicense {
        const license = new SPHLicense();

        Object.getOwnPropertyNames(license).forEach( (propertyName) => {
            console.log('propertyName: ', propertyName, '  ', json[propertyName]);
            if (
                (propertyName === 'createdAt' ||
                propertyName === 'updatedAt' ||
                  propertyName === 'last_used' ||
                propertyName === 'last_send') && json[propertyName] !== null) {
                license[propertyName] = new Date(json[propertyName]);
            } else {
                license[propertyName] = json[propertyName];
            }
         });

        license.applications = license.applications === undefined ? [] : license.applications;

        return license;
    }

    public license_nr: any = undefined;
    public company_id: any = undefined;

    public username: string = undefined;
    public hash: string = undefined;

    public locked: boolean = undefined;
    public onlyassigned: boolean = true;
    public loadprojectfiles: boolean = true;
    public extrainfos: boolean = false;
    public last_send: Date = undefined;
    public last_used: Date = undefined;
    public status: string = undefined;

    public applications: SPHApplication[] = [];

    public get applicationNamesString(): string {
            const names = this.applications.map( (app) => {
                return app.displayname;
            });
            return names.join(', ');
    }

    public toJSON(): any {
        const json = {};
        this.remoteObjectCommonsToJson(json);
        Object.getOwnPropertyNames(this).forEach( (propertyName) => {
            json[propertyName] = this[propertyName];
        });

        json['applications'] = this.sphApplicationsToJSON();
        return json;
    }

    public sphApplicationsToJSON(): any {
        return this.applications.map( (application) => {
            return { application_id : application.id  };
        });
    }
}

export interface SPHApplication {
    id: any;
    name: string;
    displayname: string;
}



// WEBPACK FOOTER //
// ./src/app/features/shared/model/sph-license.model.ts